import { createContext } from "react";

export const AssembleContext = createContext((path: string) => {});
